import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import RenderContent from 'app/products/team-view/components/layout/RenderContent';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import SectionGroup from 'app/components/general/SectionGroup';
import HeaderThin from 'app/components/layout/HeaderThin';
import { IApplicationState } from 'app/types/state';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import * as invitationActions from 'app/ducks/invitations/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as invitationSelectors from 'app/ducks/invitations/selectors';

import PaymentHistory from './features/PaymentHistory';
import YourDetails from './features/YourDetails';
import Overview from './features/Overview';
import JoinTeam from './features/JoinTeam';

interface IProps {
  actions: any;
  invitations: any;
  match: any;
  appReady: boolean;
  updateTeamSelection: Function;
}

interface IState {
  selectedTeam: any;
}

const selector = (state): any => ({
  invitations: invitationSelectors.getInvitations(state),
  appReady: loadingSelectors.appReady(state),
});

const actionCreators = _.merge(
  invitationActions,
);

const TeamViewLayout: FC<IProps> = (props: IProps = {
  actions: undefined,
  invitations: undefined,
  match: undefined,
  appReady: false,
}) => {
  // const defaultTeamSelection = {
  //   id: 'all-teams',
  //   name: 'All Teams',
  // };
  // const selectedTeam = props.dashboard.teamSelection;

  // const handleSelectTeam = (e: any): void => {
  //   props.actions.updateTeamSelection(e);
  // };

  // const teamOptions = _.concat([defaultTeamSelection], props.teams.teamsByIdInSelectFormat);

  useEffect(() => {
    props.actions.getInvitation(props.match.params.teamCode);
  }, []);

  const team = useMemo(() => props.invitations.currentInvitation.team, [JSON.stringify(props.invitations.currentInvitation)]);
  const teamManager = useMemo(() => props.invitations.currentInvitation.user, [JSON.stringify(props.invitations.currentInvitation)]);

  return (
    <RenderContent className="team-view-app" match={props.match}>
      <div className="row">
        <div className="col">
          <HeaderThin title={team?.name} divider>
            {/* <div className="col col-5 col-md-4 col-lg-3 header-thin-children">
              <InputGroupBlock
                name="timePeriod"
                // labelText="Time Period"
                className="no-margin-bottom float-right w-100"
                inputGroupClassName="no-margin-bottom w-100"
                placeholder="Team"
                type="select"
                options={teamOptions}
                value={props.dashboard.teamSelection}
                onChange={handleSelectTeam}
              />
            </div> */}
          </HeaderThin>
        </div>
      </div>

      <Route
        exact
        path={['/:teamCode', '/:teamCode/join-team']}
        render={(): React.ReactNode => <JoinTeam teamManager={teamManager} team={team} {...props} />}
      />
      <Route
        exact
        path={['/:teamCode/:teamMemberCode', '/:teamCode/:teamMemberCode/overview']}
        render={(): React.ReactNode => <Overview teamManager={teamManager} team={team} {...props} />}
      />

      <Route
        exact
        path="/:teamCode/:teamMemberCode/payment-history"
        render={(): React.ReactNode => <PaymentHistory teamManager={teamManager} team={team} {...props} />}
      />
      <Route
        exact
        path="/:teamCode/:teamMemberCode/your-details"
        render={(): React.ReactNode => <YourDetails teamManager={teamManager} team={team} {...props} />}
      />
      {/* {selectedTeam?.id === 'all-teams' && (<DashboardAllTeams {...props} />)}
      {selectedTeam?.id !== 'all-teams' && (<DashboardSingleTeam {...props} teamId={selectedTeam?.id} />)} */}

      {/* {props.users.currentUser.userType === 'team' && (
          <MyDashboardNotifications
            actions={props.actions}
            currentTeam={props.teams.currentTeam}
          />
        )}
        {props.teams.currentTeam.connectedToAssociation && (
          <MyDashboardUpcomingMatches
            actions={props.actions}
            currentTeam={props.teams.currentTeam}
          />
        )}
        <div className="row">
          <div className="col">
            <MyDashboardPayments
              actions={props.actions}
              appReady={props.appReady}
              payments={props.payments}
              teamMemberIds={props.teamMembers?.currentTeam?.teamMemberIds}
              reminders={props.reminders}
            />
          </div>
        </div> */}
    </RenderContent>
  );
};

export default connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))(TeamViewLayout);
